module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/playerHeadshots/nfl/updated_survive-a672f546b8829056df8513122b6ce991.svg";